import SEOHead from '@/components/base/SEOHead';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';

export default function Terms() {
  return (
    <>
      <SEOHead
        title="Terms and Conditions – All Yono Games"
        description="Read the terms and conditions for using All Yono Games. Understand your rights and obligations when browsing our game directory and using our services."
        keywords="Terms and Conditions, Yono Games Terms, Website Usage Terms"
      />

      <Header />

      <main>
        <div className="px-4 py-6">
          <h1 className="text-xl font-heading font-bold text-foreground-900 mb-4">
            Terms and Conditions
          </h1>
          <p className="text-foreground-400 text-[11px] mb-5">Last updated: July 13, 2026</p>

          <div className="space-y-4 text-foreground-600 text-[13px] leading-relaxed">
            <p>
              Welcome to All Yono Games. By accessing and using this website, you accept and agree to be bound by the following terms and conditions. If you do not agree with any part of these terms, please do not use our website.
            </p>

            <h2 className="font-heading font-semibold text-foreground-900 text-[15px]">Use of Website</h2>
            <p>
              All Yono Games provides an informational directory of gaming applications. The content on this website is for general informational purposes only. We do not host, distribute, or control any of the applications listed on our website. All download links direct users to external, third-party sources.
            </p>

            <h2 className="font-heading font-semibold text-foreground-900 text-[15px]">Intellectual Property</h2>
            <p>
              All game names, logos, trademarks, and related assets belong to their respective owners. All Yono Games does not claim ownership of any third-party intellectual property. Our original content, including game descriptions, articles, and website design, is protected by applicable copyright laws.
            </p>

            <h2 className="font-heading font-semibold text-foreground-900 text-[15px]">External Links</h2>
            <p>
              Our website contains links to external websites and third-party applications. We are not responsible for the content, accuracy, or practices of any third-party sites. Users access external links at their own risk. We recommend reviewing the terms and conditions of any external platform before use.
            </p>

            <h2 className="font-heading font-semibold text-foreground-900 text-[15px]">Disclaimer of Warranties</h2>
            <p>
              This website is provided on an "as is" and "as available" basis. All Yono Games makes no representations or warranties of any kind, express or implied, regarding the operation of this website or the information, content, and materials included.
            </p>

            <h2 className="font-heading font-semibold text-foreground-900 text-[15px]">Limitation of Liability</h2>
            <p>
              All Yono Games shall not be liable for any damages arising from the use or inability to use this website, including but not limited to direct, indirect, incidental, or consequential damages. This includes damages resulting from downloading or installing any application linked from our website.
            </p>

            <h2 className="font-heading font-semibold text-foreground-900 text-[15px]">Governing Law</h2>
            <p>
              These terms shall be governed by and construed in accordance with the laws of India. Any disputes relating to these terms shall be subject to the exclusive jurisdiction of the courts in India.
            </p>

            <h2 className="font-heading font-semibold text-foreground-900 text-[15px]">Changes to Terms</h2>
            <p>
              We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting to this page. Your continued use of the website after any changes constitutes acceptance of the new terms.
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}